export default "__VITE_ASSET__c406de57__"